export default __webpack_public_path__ + "static/media/Email.03e3e5cd.svg";